import { render, staticRenderFns } from "./RazorPayWebIntegration.vue?vue&type=template&id=5272b83d&"
import script from "./RazorPayWebIntegration.vue?vue&type=script&lang=js&"
export * from "./RazorPayWebIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports